import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";

export function useBrandProductName(): string {
	return useSiteTextContent("branding.productName");
}

export function useBrandMetaDescription(): string {
	return useSiteTextContent("branding.metaDescription");
}

const VOWEL_SOUND_START_CHARS = new Set([
	"a",
	"e",
	"i",
	"o",
	"u",
	"y",
	"à",
	"â",
	"ä",
	"é",
	"è",
	"ê",
	"ë",
	"î",
	"ï",
	"ô",
	"ö",
	"ù",
	"û",
	"ü",
	"h",
]);

function startsWithVowelSound(value: string): boolean {
	const s = value.trim();
	if (s.length === 0) {
		return false;
	}
	return VOWEL_SOUND_START_CHARS.has(s.charAt(0).toLowerCase());
}

/** French "de" preposition with elision (`de X` / `d'X`). */
export function buildFrenchDeOf(value: string): string {
	const s = value.trim();
	if (s.length === 0) {
		return "de";
	}
	return startsWithVowelSound(s) ? `d'${s}` : `de ${s}`;
}

export function buildBrandPageTitle(pageTitle: string, productName: string): string {
	return `${pageTitle} - ${productName}`;
}
